export default {
    'Debe ingresar al menos una falla' : "Debe ingresar al menos una falla",
    'Debe ingresar el informe al cliente' : "Debe ingresar el informe al cliente",
    'Debe dar apertura al servicio' : "Debe dar apertura al servicio",
    'Ha ocurrido un error' : "Ha ocurrido un error"
}